import userStore from "../stores/UserStore";
import { message } from "antd";
import axios from "axios";
import { ACCESS_KEY } from "../constants/StorageConstants";

export const getApi = (URL, data = {}, isAuthenticated = false) => {
  const headers = isAuthenticated
    ? {
        Authorization: "Bearer " + getAuthToken(),
      }
    : {};

  return new Promise((resolve, reject) => {
    axios({
      method: "GET",
      url: URL,
      params: data,
      headers: headers,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
        handleErrorCode(err);
      });
  });
};

export const postApi = (
  URL,
  data = {},
  method = "post",
  isAuthenticated = false
) => {
  const headers = isAuthenticated
    ? {
        Authorization: "Bearer " + getAuthToken(),
      }
    : {};

  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: URL,
      data: data,
      headers: headers,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
        handleErrorCode(err);
      });
  });
};

const getAuthToken = () => {
  return localStorage.getItem(ACCESS_KEY);
};

export const handleErrorCode = (err) => {
  if (err.response && err.response.status === 401) {
    userStore.removeUserToken();
    // window.location.href = '/';
  }
  if (err.response && err.response.data) {
    message.error(err.response.data.detail);
  }
};
